import { SMS_CODE_SENT_STATUS_MAPPING } from "../MFAEnroll/constants";
import { STATUS } from "../../../constants";

const { SUCCEED, FAILED } = STATUS;

const MessageTip = ({ statusObj, mapping = SMS_CODE_SENT_STATUS_MAPPING }) => {
  if (![SUCCEED, FAILED].includes(statusObj.status)) {
    return null;
  }

  const mapObj = mapping[statusObj.status];
  const message = statusObj.status === SUCCEED ? mapObj?.message : statusObj.error;

  if (statusObj.status === FAILED) {
    return (
      <p className="public-secure-file-inline-error" role="alert">
        <i className="fas fa-circle-exclamation" aria-hidden="true" />
        {message}
      </p>
    );
  }

  return (
    <div
      className="public-secure-file-notice"
      style={{ background: "var(--psf-success-bg)", color: "var(--psf-success)" }}
    >
      <i className="fas fa-circle-check" aria-hidden="true" />
      <p>{message}</p>
    </div>
  );
};

export default MessageTip;
